/*
 * Copyright (c) Nexign, JSC, 2021.
 */

/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

export interface IWizardAdditionalAccountsValidation {
    error: string;
    isValid: boolean;
}

export enum EAdditionalAccountType {
    PERSONAL = 'PERSONAL',
    CONTENT = 'CONTENT',
}

export interface IWizardAdditionalAccountsStartData {
    accountType?: EAdditionalAccountType;
}
